var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.processType != null)?_c('el-tag',{attrs:{"size":"medium","type":_vm.cssClass}},[(!!_vm.icon)?_c('i',{class:[_vm.icon]}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.processTypeLabel)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1da2280","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/doc-process-type-tag.vue
// module id = 5Dbo
// module chunks = 89